import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { deleteToast } from '../../../store/slices/uiContextSlice';
import ToastItem from './ToastItem';

export default function ToastList({
  list,
  position,
  autoDelete,
  autoDeleteTime,
}) {
  const dispatch = useDispatch();
  const positionClassName = {
    topLeft: 'top-16 md:top-4 sm:left-2',
    topRight: 'top-16 md:top-4 sm:right-2',
    bottomLeft: 'bottom-16 md:bottom-4 sm:left-2',
    bottomRight: 'bottom-16 md:bottom-4 sm:right-2',
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoDelete && list.length && list.length) {
        dispatch(deleteToast(list[0].id));
      }
    }, autoDeleteTime);

    return () => {
      clearInterval(interval);
    };
  }, [list, autoDelete, autoDeleteTime, dispatch]);

  return (
    <div
      className={`fixed z-50 mx-auto box-border max-w-sm px-2 text-sm transition-transform duration-500 ease-in-out max-[639px]:left-0 max-[639px]:right-0 ${positionClassName[position]}`}
    >
      {list.map((item) => (
        <ToastItem
          key={item.id}
          toast={item}
          position={position}
          handleCloseButton={() => {
            dispatch(deleteToast(item.id));
          }}
        />
      ))}
    </div>
  );
}

ToastList.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.oneOf([
        'success',
        'warning',
        'danger',
        'primary',
        'secondary',
      ]),
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
  position: PropTypes.oneOf([
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
  ]).isRequired,
  autoDelete: PropTypes.bool,
  autoDeleteTime: PropTypes.number,
};
